module.exports = "pegasus_template/assets/theme4/arrow.png";